import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const nav = [
    { to: '/games', label: 'Games' },
    { to: '/game-tracker', label: 'Game Tracker' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Submit' },
  ];

  const isActive = (path: string) => path === '/' ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <div className="layout">
      <header className="hd">
        <div className="hd-inner container">
          <Link to="/" className="hd-logo">practical media</Link>
          <nav className={`hd-nav ${menuOpen ? 'hd-nav-open' : ''}`}>
            {nav.map(n => (
              <Link key={n.to} to={n.to} className={isActive(n.to) ? 'active' : ''} onClick={() => setMenuOpen(false)}>{n.label}</Link>
            ))}
          </nav>
          <button className="burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span className={menuOpen ? 'burger-x' : ''} />
            <span className={menuOpen ? 'burger-x' : ''} />
          </button>
        </div>
      </header>

      <main>{children}</main>

      <footer className="ft">
        <div className="ft-top container">
          <div className="ft-col">
            <Link to="/" className="ft-logo">practical media</Link>
            <p className="ft-desc">Developer-first game publishing. From the founder of <a href="https://solodevelopment.org" target="_blank" rel="noopener noreferrer">SoloDevelopment</a>.</p>
          </div>
          <div className="ft-col">
            <p className="ft-label">Navigate</p>
            <div className="ft-links">
              <Link to="/games">Games</Link>
              <Link to="/game-tracker">Game Tracker</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Submit</Link>
            </div>
          </div>
          <div className="ft-col">
            <p className="ft-label">Games</p>
            <div className="ft-links">
              <Link to="/games/spell-code-slingerz">Spell Code SlingerZ</Link>
              <Link to="/games/baiacool">Baiacool</Link>
              <Link to="/games/arcane-audit">Arcane Audit</Link>
              <Link to="/games/memori">Memori</Link>
              <Link to="/games">All games</Link>
            </div>
          </div>
          <div className="ft-col">
            <p className="ft-label">Connect</p>
            <div className="ft-links">
              <a href="https://discord.com/invite/U7dYpq5yMK" target="_blank" rel="noopener noreferrer nofollow">Discord</a>
              <a href="https://www.twitch.tv/practicalnpc" target="_blank" rel="noopener noreferrer nofollow">Twitch</a>
              <a href="https://bsky.app/profile/practicalnpc.bsky.social" target="_blank" rel="noopener noreferrer nofollow">Bluesky</a>
              <a href="https://solodevelopment.org" target="_blank" rel="noopener noreferrer">SoloDevelopment</a>
            </div>
          </div>
        </div>
        <div className="ft-bottom container">
          <span>&copy; {new Date().getFullYear()} Practical Media. All rights reserved.</span>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
};
